import baseConfig from './config';
import MockService from '../mocks/mockService';

// Development environment configuration
const developmentConfig = {
  ...baseConfig,
  // Base URL for API calls in development
  baseUrl: 'http://localhost:8000',
  
  // Development-specific settings
  debug: true,
  environment: 'development',
  
  // Mock API services
  services: {
    getTests: () => MockService.getTests(),
    sendOtp: (mobile, courseType) => MockService.sendOtp(mobile, courseType),
    verifyOtp: (mobile, otp, courseType) => MockService.verifyOtp(mobile, otp, courseType)
  }
};

export default developmentConfig; 